import SingleSelectTree from './SingleSelectTree';

export default SingleSelectTree;